import { statsData } from "@/mocks/trending";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=large%20warm%20editorial%20papercut%20collage%20of%20internet%20trending%20culture%20with%20smartphones%2C%20mega%20speaker%2C%20floating%20speech%20bubbles%2C%20fire%20and%20upward%20trending%20arrows%2C%20on%20a%20soft%20cream%20and%20beige%20background%2C%20vermilion%20red%20and%20golden%20yellow%20flat%20shapes%2C%20minimal%20modern%20flat%20design%2C%20plenty%20of%20empty%20space%20in%20center%20for%20text%2C%20warm%20neutral%20tone%2C%20clean%20artistic%20composition&width=1920&height=1280&seq=hero-cover-01&orientation=landscape"
          alt="吃瓜爆网全网热点追踪横幅插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-950/25 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 pb-10 pt-32 md:px-8 md:pt-40">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
            </span>
            全网热点 · 每日追踪 · 转发过万出圈梗合集
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            全网爆传，刷屏出圈
            <br />
            <span className="text-accent-400">今天你吃瓜了吗？</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-100/95 md:text-lg">
            吃瓜爆网专注网络爆传刷屏内容与转发过万出圈梗的深度盘点，疯狂传播事件持续追踪。热点来了不迷路，深度复盘不错过，带你快速跟上全网节奏。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#board"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              看今日热榜
              <i className="ri-arrow-down-line ml-2" aria-hidden="true"></i>
            </a>
            <a
              href="#features"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              读深度盘点
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-50/20 bg-background-50/15 backdrop-blur sm:grid-cols-4">
            {statsData.map((s) => (
              <div key={s.label} className="bg-background-950/20 px-4 py-5 text-center">
                <p className="font-heading text-2xl font-black text-accent-400 md:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs text-background-100/85">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}